import styled, { css } from 'styled-components'

import { cssError } from '@/styles/errorValidation'

export const Container = styled.div<{
	disabled?: boolean
	hasNoBorder?: boolean
}>`
	width: 100%;
	display: flex;
	border: ${(props) =>
		`${props.hasNoBorder ? 'none' : `1px solid ${props.theme.colors.input.border}`}`};
	padding: 5px 10px;
	background: ${(props) =>
		`${props.disabled ? props.theme.colors.input.disabled.background : ''}`};
`

export const Clear = styled.div`
	position: absolute;
	opacity: 0.5;
	right: 12px;
	top: 0;
	transform: translate(50%, 50%);
	cursor: pointer;
`

interface InputProps {
	$compact: boolean
	$error?: string | null
	$hasIcon?: boolean
	disabled?: boolean
}

export const Input = styled.input<InputProps>`
	border: 1px solid black;
	background-color: ${(props) =>
		props.disabled ? props.theme.colors.input.disabled : 'none'};
	height: 100%;
	${cssError}

	&& {
		${(props) => css`
			border-color: ${props.$compact
				? `${props.theme.colors.input.$compact.horizontalBorder} ${props.theme.colors.input.$compact.verticalBorder}`
				: props.theme.colors.input.border};
			border-radius: ${props.$compact ? 0 : props.theme.input.borderRadius};
			padding: ${props.$compact
				? props.theme.input.compact.padding
				: props.theme.input.padding};
			:focus {
				border-color: ${props.theme.colors.primary.base};
				box-shadow: 0 0 3px ${props.theme.colors.primary.shadowColor};
			}
			:hover {
				box-shadow: ${props.disabled
					? 'none'
					: `0 0 3px ${props.theme.colors.primary.shadowColor}`};
			}
		`}

		${(props) =>
			props.$hasIcon &&
			css`
				padding-left: 24px;
			`}

		${(props) =>
			props.$compact &&
			css`
				height: 26px;
			`}
	}
`
